module.exports = __webpack_public_path__ + "static/blog-post-692dd800a12410bcf0e598e5dc62d249.png";